// src/currency.ts
var CurrencySymbols = {
  DOP: "RD$",
  USD: "US$"
};

// src/vehicle.ts
var VehicleCategoryType = /* @__PURE__ */ ((VehicleCategoryType2) => {
  VehicleCategoryType2["AUTOMOBILE"] = "Carro";
  VehicleCategoryType2["MOTORCYCLE"] = "Motocicleta";
  return VehicleCategoryType2;
})(VehicleCategoryType || {});
var VehicleCondition = /* @__PURE__ */ ((VehicleCondition2) => {
  VehicleCondition2["NEW"] = "Nuevo";
  VehicleCondition2["IMPORTED"] = "Importada";
  VehicleCondition2["USED"] = "Usado";
  VehicleCondition2["REFURBISHED"] = "Reacondicionado";
  return VehicleCondition2;
})(VehicleCondition || {});
var VehicleWarranty = /* @__PURE__ */ ((VehicleWarranty2) => {
  VehicleWarranty2["ONE_MONTH"] = "1 Mes";
  VehicleWarranty2["THREE_MONTHS"] = "3 Meses";
  VehicleWarranty2["SIX_MONTHS"] = "6 Meses";
  VehicleWarranty2["ONE_YEAR"] = "1 A\xF1o";
  VehicleWarranty2["TWO_YEARS"] = "2 A\xF1os";
  VehicleWarranty2["EXTENDED"] = "Garant\xEDa Extendida";
  return VehicleWarranty2;
})(VehicleWarranty || {});
var EngineType = /* @__PURE__ */ ((EngineType2) => {
  EngineType2["GASOLINE"] = "Gasolina";
  EngineType2["GLP"] = "GLP";
  EngineType2["ELECTRIC"] = "El\xE9ctrico";
  EngineType2["HYBRID"] = "H\xEDbrido";
  EngineType2["DIESEL"] = "Di\xE9sel";
  return EngineType2;
})(EngineType || {});
var TransmissionType = /* @__PURE__ */ ((TransmissionType2) => {
  TransmissionType2["MANUAL"] = "Manual";
  TransmissionType2["AUTOMATIC"] = "Autom\xE1tica";
  TransmissionType2["CVT"] = "CVT";
  TransmissionType2["SEMI_AUTOMATIC"] = "Semi-autom\xE1tica";
  return TransmissionType2;
})(TransmissionType || {});
var CarBodyType = /* @__PURE__ */ ((CarBodyType2) => {
  CarBodyType2["SEDAN"] = "Sed\xE1n";
  CarBodyType2["SUV"] = "SUV";
  CarBodyType2["HATCHBACK"] = "Hatchback";
  CarBodyType2["PICKUP"] = "Pickup";
  CarBodyType2["VAN"] = "Van";
  CarBodyType2["COUPE"] = "Coup\xE9";
  CarBodyType2["CONVERTIBLE"] = "Convertible";
  return CarBodyType2;
})(CarBodyType || {});
var DriveType = /* @__PURE__ */ ((DriveType2) => {
  DriveType2["FWD"] = "Tracci\xF3n delantera";
  DriveType2["RWD"] = "Tracci\xF3n trasera";
  DriveType2["AWD"] = "Tracci\xF3n integral";
  DriveType2["FOUR_WD"] = "4x4";
  return DriveType2;
})(DriveType || {});
function isAutomobile(v) {
  const t = v.type;
  return t === "Carro" /* AUTOMOBILE */ || t === "Carro";
}
function isMotorcycle(v) {
  const t = v.type;
  return t === "Motocicleta" /* MOTORCYCLE */ || t === "Motocicleta" || !t;
}
export {
  CarBodyType,
  CurrencySymbols,
  DriveType,
  EngineType,
  TransmissionType,
  VehicleCategoryType,
  VehicleCondition,
  VehicleWarranty,
  isAutomobile,
  isMotorcycle
};
